import { render, staticRenderFns } from "./QuerySQForm.vue?vue&type=template&id=6d632032&scoped=true"
import script from "./QuerySQForm.ts?vue&type=script&lang=ts&external"
export * from "./QuerySQForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d632032",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d632032')) {
      api.createRecord('6d632032', component.options)
    } else {
      api.reload('6d632032', component.options)
    }
    module.hot.accept("./QuerySQForm.vue?vue&type=template&id=6d632032&scoped=true", function () {
      api.rerender('6d632032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/LOPD/components/PSQueryForm/QuerySQForm.vue"
export default component.exports